/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListWorkTypesResponseDto,
  WorkTypeResponseDto,
} from '../models/index';
import {
    ListWorkTypesResponseDtoFromJSON,
    ListWorkTypesResponseDtoToJSON,
    WorkTypeResponseDtoFromJSON,
    WorkTypeResponseDtoToJSON,
} from '../models/index';

export interface WorkTypeControllerFindByIdRequest {
    id: string;
}

/**
 * 
 */
export class PreventiveMaintenanceWorkTypesApi extends runtime.BaseAPI {

    /**
     */
    async workTypeControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWorkTypesResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/work-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWorkTypesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async workTypeControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWorkTypesResponseDto> {
        const response = await this.workTypeControllerFindAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async workTypeControllerFindByIdRaw(requestParameters: WorkTypeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkTypeResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workTypeControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/preventive-maintenance/work-types/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkTypeResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async workTypeControllerFindById(requestParameters: WorkTypeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkTypeResponseDto> {
        const response = await this.workTypeControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
